import Input from './Input';
import RadioGroup from './RadioGroup';
import Select from './Select';
import Button from './Button';
import ActionButton from './ActionButton';
import Textarea from './Textarea';
import SelectValuePopup from './SelectValuePopup'
import AddMissingKey from './AddMissingKey'


// Import form controls here and import only this file when building forms
const Controls = {
  Input,
  RadioGroup,
  Select,
  Button,
  ActionButton,
  Textarea,
  SelectValuePopup,
  AddMissingKey
  };

export default Controls;
